import { User as Auth0User } from '@auth0/auth0-spa-js';

export class User extends Auth0User {
  objectId?: string;

  constructor(auth0User?: Auth0User) {
    super();

    if (!auth0User) return;

    for (const key in auth0User) {
      this[key] = auth0User[key];
    }

    this.objectId = auth0User['http://onsend.com/identity/claims/objectid'] as string;
  }
}
